import React from "react";
export const DotIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="3"
    height="3"
    viewBox="0 0 3 3"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.83736 2.78232C1.58499 2.78232 1.36802 2.69306 1.18643 2.51456C1.00485 2.33298 0.914062 2.11446 0.914062 1.85902C0.914062 1.60665 1.00485 1.39122 1.18643 1.21271C1.36802 1.03113 1.58499 0.940341 1.83736 0.940341C2.08973 0.940341 2.3067 1.03113 2.48828 1.21271C2.66986 1.39122 2.76065 1.60665 2.76065 1.85902C2.76065 2.02829 2.71757 2.18371 2.63139 2.32528C2.5483 2.46378 2.4375 2.57457 2.29901 2.65767C2.16051 2.74077 2.00663 2.78232 1.83736 2.78232Z"
      fill="currentColor"
    />
  </svg>
);
